import { Component } from '@angular/core';

@Component({
    selector: 'administration-user',
    templateUrl: './administration-global.component.html',
})
export class AdministrationGlobalComponent {}
